import {
  BLOCKPAGE_PAGEUI_UPDATE,
  BLOCKPAGE_BLOCKUI_UPDATE,
  SET_PAGE_FAVOURITED,
  SET_PAGE_SUBSCRIBED_ACTION_TYPES,
  SET_PAGE_TRAVERSAL_LINKS,
  SET_PAGE_DISPLAY_OPTIONS,
  SET_COMMUNITY_OPTIONS,
  BLOCKPAGE_DATA_LOADED_SUCCESS,
  SET_BLOCKPAGE_UI_MODE,
  SET_IS_COMMENT_REQUIRED_START,
  SET_IS_COMMENT_REQUIRED_SUCCESS,
  SET_IS_COMMENT_REQUIRED_FAILURE,
  BLOCKPAGE_UNMOUNT,
  BLOCKPAGE_OPEN_SHARE_MODAL,
  SET_TURNITIN_EULA_ACCEPTED,
} from './actions';
import { ResourceApi } from '../../resource/Resource';
import { subscribeToBlock, unsubscribeAllBlocks } from './channels';

export const setBlockPageUIMode = (mountId, mode) => ({
  type: SET_BLOCKPAGE_UI_MODE,
  mountId,
  mode, // eg. PageMode.VIEW
});

export const updateBlockPageUI = (mountId, changes) => ({
  type: BLOCKPAGE_PAGEUI_UPDATE,
  mountId,
  changes,
});

export const updateBlockUI = (mountId, blockIds, changes) => ({
  type: BLOCKPAGE_BLOCKUI_UPDATE,
  mountId,
  blockIds,
  changes,
});

export const setPageFavourited = (pagePath, isFavourited) => ({
  type: SET_PAGE_FAVOURITED,
  pagePath,
  isFavourited,
});

export const setPageSubscribedActionTypes = (pagePath, actionTypes) => ({
  type: SET_PAGE_SUBSCRIBED_ACTION_TYPES,
  pagePath,
  actionTypes,
});

export const setPageTraversalLinks = (pagePath, traversalLinks) => ({
  type: SET_PAGE_TRAVERSAL_LINKS,
  pagePath,
  traversalLinks,
});

export const setPageDisplayOptions = (pagePath, displayOptions) => ({
  type: SET_PAGE_DISPLAY_OPTIONS,
  pagePath,
  displayOptions,
});

export const setCommunityOptions = (pageId, communityOptions) => ({
  type: SET_COMMUNITY_OPTIONS,
  pageId,
  communityOptions,
});

export const setTurnitinEulaAcceptance = (mountId) => ({
  type: SET_TURNITIN_EULA_ACCEPTED,
  mountId,
});

export const onBlockPageDataLoaded = (
  mountId,
  pageId,
  pageRevisionId,
  pagePath,
  data
) => (dispatch) => {
  dispatch({
    type: BLOCKPAGE_DATA_LOADED_SUCCESS,
    mountId,
    pageId,
    pageRevisionId,
    pagePath,
    ...data,
  });
  const blocks = data.blockData.blockList.filter((block) => block.liveEvents);

  blocks.forEach((block) => {
    block.liveEvents.forEach((event) => {
      dispatch(subscribeToBlock(mountId, block.id, event));
    });
  });
};

export const unmountBlockPageUI = (mountId) => (dispatch) => {
  dispatch({
    type: BLOCKPAGE_UNMOUNT,
    mountId,
  });

  unsubscribeAllBlocks(mountId);
};

export const setIsCommentRequired = (pageId, pagePath, isCommentRequired) => (
  dispatch
) => {
  dispatch({ type: SET_IS_COMMENT_REQUIRED_START, pagePath, pageId });
  return ResourceApi.update('page', pagePath, 'setCommentRequired', {
    isCommentRequired,
  }).then(
    () => {
      dispatch({
        type: SET_IS_COMMENT_REQUIRED_SUCCESS,
        pageId,
        isCommentRequired,
      });
    },
    (error) => {
      dispatch({ type: SET_IS_COMMENT_REQUIRED_FAILURE, error });
    }
  );
};

export const openShareModal = ({
  blockId,
  shareType,
  userData,
  onPost,
  mountId,
  typingDnaData,
}) => ({
  type: BLOCKPAGE_OPEN_SHARE_MODAL,
  blockId,
  shareType,
  userData,
  onPost,
  mountId,
  typingDnaData,
});

/**
 * Remove a particular attachment
 */
export const removeAttachment = ({ blockId, groupId, attachmentId }) => (
  // eslint-disable-next-line no-unused-vars
  dispatch
) => {
  ResourceApi.update('block', blockId, 'removeUserAttachment', {
    group: groupId,
    id: attachmentId,
  });
};
